import {getColor} from "@/styles/ThemeConfig";
import PinDinnerIcon from '/public/images/pin_dinner_green.svg';
import PinCocktailIcon from '/public/images/pin_cocktail_green.svg';
import styled from "@emotion/styled";
import {Button} from "@/components/base/Buttons";
import {useEffect, useState} from "react";
import {breakpoints} from "@/styles/sizes";


const ItemsWrapper = styled.div`
    position: relative;
    margin-left: 10px;
    padding-bottom: 5px;
    border-left: 1px dashed #d6d6d6;

    margin-bottom: 40px;
`
const ListItem = styled.div`
    margin-top: 34px;
    position: relative;
    padding-left: 27px;
    font-size: 16px;
    font-family:'Poppins'!important;

    :first-child{
        margin-top: 10px;
    }
    :before{
        content: '';
        position: absolute;
        top: 0;
        left: -11px;
        width: 26px;
        height: 28px;
        background: url(${ ({isUpgrade}) => isUpgrade ?  PinCocktailIcon?.src : PinDinnerIcon?.src}) no-repeat;
    }

    @media only screen and (${breakpoints.mobile}) {
        margin-top: 20px;
    }

`

const ListItemUpgrade = styled.div`
    margin-top: 34px;
    position: relative;
    padding-left: 27px;
    font-size: 16px;
    font-family:'Poppins'!important;

    :first-child{
        margin-top: 0;
    }

    :before{
        content: '';
        position: absolute;
        top: 0;
        left: -11px;
        width: 26px;
        height: 28px;
        background: url(${PinCocktailIcon?.src}) no-repeat;
    }

    @media only screen and (${breakpoints.mobile}) {
        margin-top: 20px;
    }
`

const UpgradeTourDescription = styled.p`
    text-transform: uppercase;
    a{
        color:${getColor('gold')};
        text-decoration: none;
        font-family: 'Poppins'!important;
    }
`

// The brief asks for both of these to step down on mobile; an inline style has
// nowhere to put a media query.
const SectionTitle = styled.h2`
    color: #0E3325;
    // 32px, not the 36px the other section titles use: this one sits right under
    // the hero's H2 and at the same size the two read as one block.
    font-size: 32px;
    line-height: 42px;
    font-weight: bold;
    font-family: 'Josefin Sans';
    // Safety valve: the halves above are unbreakable, so a very long city on a
    // narrow screen would otherwise run past the edge.
    overflow-wrap: break-word;

    @media only screen and (${breakpoints.mobile}) {
        font-size: 25px;
        line-height: 34px;
    }
`;

const ItineraryTitle = styled.h3`
    color: ${getColor('gold')};
    font-size: 24px;
    font-weight: bold;
    font-family: 'Josefin Sans';
    text-transform: uppercase;
    margin-top: 30px;

    @media only screen and (${breakpoints.mobile}) {
        font-size: 20px;
    }
`;

const ContentWrapper = styled.div`
    width: 100%;
    p, li, div{
        font-family: 'Poppins'!important;
        line-height: 26px!important;
    }

    .desc p{
        font-size: 18px!important;
        line-height: 26px!important;
        font-family: 'Poppins'!important;
    }
    .desc a{
        font-size: 18px!important;
        font-family: 'Poppins'!important;
    }
`

// The brief wants this heading broken after "on" when it needs two lines:
//   What You'll Experience on
//   Our Paris Food Tour
// Rather than forcing that break, every space except the one after "on" is made
// non-breaking. A short city then still fits on one line, and when it does not,
// the only place the line can break is the one the brief asked for. Only the
// standalone word is matched, so "Lisbon" is left alone, and a heading without
// it - a tour's own wording, or a translated one - wraps normally.
const breakAfterOnWhenNeeded = (title) => {
    const match = /^(.*?\bon)\s+(.+)$/s.exec(title);

    if (!match) {
        return title;
    }

    const keepTogether = (part) => part.replace(/\s+/g, '\u00A0');

    return `${keepTogether(match[1])} ${keepTogether(match[2])}`;
};

export default function VariantBWillDoSection({
    title,
    description,
    items,
    isUpgrade,
    upgradeTour,
    note,
    itineraryLabel,
    ...rest
})
{
    const [isClient, setIsClient] = useState(false);
    useEffect(() => { setIsClient(true); }, []);

    return <ContentWrapper className={'container'} {...rest}>
        {title && <SectionTitle>{breakAfterOnWhenNeeded(title)}</SectionTitle>}

        {isClient && <p className={'desc'} dangerouslySetInnerHTML={{__html:description}}/>}

        <ItineraryTitle>{itineraryLabel || 'SEE ITINERARY'}</ItineraryTitle>


        <ItemsWrapper>
            {items?.map((item, index) => {
                return <ListItem key={index} isUpgrade={isUpgrade}  style={{fontSize:'16px!important'}}>
                    {
                        item?.title && <p style={{
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                        }}>{item?.title}</p>
                    }

                    {item?.description}
                </ListItem>
            })}
        </ItemsWrapper>

        {upgradeTour && <>
            <UpgradeTourDescription dangerouslySetInnerHTML={{__html:upgradeTour?.data?.info?.description}}/>
            <ItemsWrapper>
                {upgradeTour?.data?.whatYouWillDo?.items?.map((item, index) => {
                    return <ListItemUpgrade key={index} style={{fontSize:'16px!important'}}>
                        {
                            !isUpgrade ?
                                item?.title
                                :
                                <>
                                    {
                                        item?.title && <p style={{
                                            fontWeight: 'bold',
                                            textTransform: 'uppercase',
                                        }}>{item?.title}</p>
                                    }

                                    {item?.description}
                                </>
                        }

                    </ListItemUpgrade>
                })}
            </ItemsWrapper>

            <Button
                variant={'green'}
                href={upgradeTour?.slug}
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "0px",
                    width: "370px",
                    maxWidth:'100%',
                    height: "50px",
                    background: "#144733",
                    flex: "none",
                    order: 0,
                    flexGrow: 0,
                    paddingTop:'5px',
                    }}
            >ADD UPGRADED DRINKS PACKAGE</Button>
        </>}

        {
            note &&
            <p
                style={{
                    marginTop: '50px',
                    whiteSpace: 'pre-line',
                    fontFamily: "'Inter'",
                    fontStyle: "italic",
                    fontWeight: 400,
                    fontSize: "16px",
                    lineHeight: "22px",
                    display: "flex",
                    alignItems: "center",
                    color: "#144733",
                    flex: "none",
                    order: 7,
                    alignSelf: "stretch",
                    flexGrow: 0,
                    marginBottom:'20px',
                }}
                dangerouslySetInnerHTML={{ __html: note.replace(/\n/g, '<br>') }}
            />
        }

    </ContentWrapper>
}
